import { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

// Notice kinds from the backend's three-way comparison (base / theirs / mine).
const KIND = {
  changed:  { label: 'Yleinen rivi muuttunut',            theirs: 'Ota yleisen versio',   mine: 'Pidä oma',        def: 'theirs', badge: 'bg-info' },
  conflict: { label: 'Muuttunut, ja olet muokannut itse', theirs: 'Ota yleisen versio',   mine: 'Pidä oma',        def: 'mine',   badge: 'bg-warning text-dark' },
  added:    { label: 'Uusi yleinen rivi',                 theirs: 'Lisää omaan',          mine: 'Ohita',           def: 'theirs', badge: 'bg-success' },
  removed:  { label: 'Poistettu yleisestä',               theirs: 'Poista omasta',        mine: 'Pidä omassa',     def: 'theirs', badge: 'bg-secondary' },
};

function Text({ label, row, muted }) {
  if (!row) return null;
  return (
    <div className="mb-1">
      <div className="text-muted" style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '.03em' }}>{label}</div>
      <div className={`border rounded px-2 py-1 ${muted ? 'bg-light' : 'bg-white'}`} style={{ fontSize: '0.82rem', whiteSpace: 'pre-wrap' }}>
        <span className="text-muted">{row.heading}: </span>{row.content}
      </div>
    </div>
  );
}

export default function MergeDialog({ show, notices, onCancel, onConfirm, saving, error }) {
  const [decisions, setDecisions] = useState({});

  useEffect(() => {
    if (show) setDecisions(Object.fromEntries(notices.map(n => [n.item_id, KIND[n.kind].def])));
  }, [show, notices]);

  return (
    <Modal show={show} onHide={onCancel} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1rem' }}>Päivitä oma versio yleisestä</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted" style={{ fontSize: '0.85rem' }}>
          Yleistä promptia on muutettu sen jälkeen, kun oma versiosi päivitettiin. Valitse jokaisesta muutoksesta,
          mitä omaan versioon tehdään. Valinnoista syntyy yksi uusi oma versio.
        </p>
        {notices.map((n) => {
          const k = KIND[n.kind];
          return (
            <div key={n.item_id} className="border rounded p-2 mb-2">
              <span className={`badge ${k.badge} mb-2`}>{k.label}</span>
              {n.kind === 'conflict' && <Text label="Alkuperäinen yleinen" row={n.base} muted />}
              {n.kind !== 'removed' && <Text label="Uusi yleinen" row={n.theirs} />}
              {n.kind === 'removed' && <Text label="Poistettu yleisestä" row={n.base} muted />}
              {n.mine && <Text label="Sinun versiosi" row={n.mine} />}
              <div className="d-flex gap-3 mt-1">
                {['theirs', 'mine'].map((choice) => (
                  <label key={choice} className="d-flex align-items-center gap-1" style={{ fontSize: '0.85rem' }}>
                    <input
                      type="radio"
                      name={`merge-${n.item_id}`}
                      checked={decisions[n.item_id] === choice}
                      onChange={() => setDecisions(d => ({ ...d, [n.item_id]: choice }))}
                    />
                    {k[choice]}
                  </label>
                ))}
              </div>
            </div>
          );
        })}
        {error && <div className="alert alert-danger py-1 px-2 mt-2" style={{ fontSize: '0.85rem' }}>{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onCancel} disabled={saving}>Peru</Button>
        <Button variant="success" onClick={() => onConfirm(decisions)} disabled={saving}>
          {saving ? 'Tallennetaan…' : 'Tallenna uusi oma versio'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
